import React from 'react';
interface PrivacySectionProps {
  id: string;
  number: number;
  title: string;
  children: React.ReactNode;
  isLast?: boolean;
}
export function PrivacySection({
  id,
  number,
  title,
  children,
  isLast = false
}: PrivacySectionProps) {
  return <section id={id} className="scroll-mt-28" data-id="element-186">
      <div className="mb-6" data-id="element-187">
        <p className="font-sans text-sm font-semibold text-sky mb-3 uppercase" style={{
        letterSpacing: '0.08em'
      }} data-id="element-188">
          Section {String(number).padStart(2, '0')}
        </p>
        <h2 className="font-serif text-[32px] md:text-[48px] text-navy leading-[1.15]" data-id="element-189">
          {title}
        </h2>
      </div>
      <div className="prose-privacy" data-id="element-190">{children}</div>
      {!isLast && <div className="my-16 h-px bg-slate-light" data-id="element-191" />}
    </section>;
}